
      /*
  Mini Cart Controller
*/

      (function () {
        function waitFor(sel, { timeout = 10000 } = {}) {
          return new Promise((res, rej) => {
            const el = document.querySelector(sel);
            if (el) return res(el);

            const mo = new MutationObserver(() => {
              const n = document.querySelector(sel);
              if (n) {
                mo.disconnect();
                res(n);
              }
            });

            mo.observe(document.documentElement, { childList: true, subtree: true });

            setTimeout(() => {
              mo.disconnect();
              rej(new Error(`Timeout: ${sel}`));
            }, timeout);
          });
        }

        function waitForAll(sel, min = 1, { timeout = 10000 } = {}) {
          return new Promise((res, rej) => {
            const get = () => Array.from(document.querySelectorAll(sel));
            const now = get();
            if (now.length >= min) return res(now);

            const mo = new MutationObserver(() => {
              const els = get();
              if (els.length >= min) {
                mo.disconnect();
                res(els);
              }
            });

            mo.observe(document.documentElement, { childList: true, subtree: true });

            setTimeout(() => {
              mo.disconnect();
              rej(new Error(`Timeout: ${sel} (min ${min})`));
            }, timeout);
          });
        }

        function hardStop(e) {
          if (!e) return;
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        }

        function ensureFocusable(el) {
          if (!el) return;
          if (el.getAttribute('tabindex') === null) el.setAttribute('tabindex', '-1');
        }

        async function initMiniCart() {
          try {
            // Prefer data attribute triggers to support two navbars
            // Add data-cart-toggle to each cart icon. Fallback to #mini-cart-toggle if present.
            let triggers = Array.from(document.querySelectorAll('[data-cart-toggle]'));
            if (!triggers.length) {
              const fallback = await waitFor('#mini-cart-toggle');
              triggers = [fallback];
            }

            const panel = await waitFor('.mini-cart_component');
            const overlay = await waitFor('.menu-overlay');

            // IMPORTANT: scope close button to mini-cart to avoid selecting the search close button
            const closeBtn = await waitFor('.mini-cart_component .nav-close-button');

            // Ensure panel is not hard-hidden
            panel.removeAttribute('hidden');

            // Accessibility
            panel.id = panel.id || 'mini-cart-dialog';
            const title = panel.querySelector('#mini-cart-title, h3, .heading-style-h2');
            if (title) title.id = title.id || 'mini-cart-title';

            triggers.forEach((btn) => {
              btn.setAttribute('aria-controls', panel.id);
              btn.setAttribute('aria-haspopup', 'dialog');
              btn.setAttribute('aria-expanded', 'false');
              if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', 'Open cart');
            });

            closeBtn.setAttribute('aria-label', 'Close cart');

            panel.setAttribute('role', 'dialog');
            panel.setAttribute('aria-modal', 'true');
            panel.setAttribute('aria-hidden', 'true');
            if (title) panel.setAttribute('aria-labelledby', title.id);
            ensureFocusable(panel);

            overlay.style.zIndex = '9998';

            const hasGSAP = typeof window.gsap !== 'undefined';

            // Avoid flash
            if (hasGSAP) {
              panel.style.visibility = 'hidden';
              requestAnimationFrame(() => {
                panel.style.visibility = 'visible';
                window.gsap.set(panel, { xPercent: 100, autoAlpha: 0, zIndex: 9999 });
              });
            } else {
              panel.style.transform = 'translateX(100%)';
              panel.style.opacity = '0';
              panel.style.visibility = 'hidden';
              panel.style.zIndex = '9999';
            }

            // Overlay helpers (preserve other states)
            function overlayShow() {
              overlay.classList.add('cart-active');
              overlay.classList.add('active'); // aligns with common overlay CSS
              overlay.style.pointerEvents = 'auto';
              overlay.setAttribute('aria-hidden', 'false');

              // If overlay is display:none by default, force it
              if (getComputedStyle(overlay).display === 'none') overlay.style.display = 'block';

              if (hasGSAP) window.gsap.to(overlay, { autoAlpha: 1, duration: 0.3 });
              else {
                overlay.style.opacity = '1';
                overlay.style.visibility = 'visible';
              }
            }

            function overlayHideIfIdle() {
              overlay.classList.remove('cart-active');
              overlay.style.pointerEvents = 'none';
              overlay.setAttribute('aria-hidden', 'true');

              // Keep overlay if search/menu still needs it
              const stillNeeded =
                overlay.classList.contains('search-active') ||
                overlay.classList.contains('menu-active') ||
                overlay.classList.contains('active-search') ||
                overlay.classList.contains('active-menu');

              if (stillNeeded) return;

              overlay.classList.remove('active');

              if (hasGSAP) window.gsap.to(overlay, { autoAlpha: 0, duration: 0.3 });
              else {
                overlay.style.opacity = '0';
                overlay.style.visibility = 'hidden';
              }
            }

            function openPanel(btn) {
              overlayShow();

              panel.setAttribute('aria-hidden', 'false');
              triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));

              if (hasGSAP) {
                window.gsap.to(panel, {
                  xPercent: 0,
                  autoAlpha: 1,
                  duration: 0.3,
                  ease: 'power2.out',
                  onComplete: () => panel.focus(),
                });
              } else {
                panel.style.visibility = 'visible';
                panel.style.opacity = '1';
                panel.style.transform = 'translateX(0)';
                panel.focus();
              }
            }

            function closePanel() {
              if (panel.contains(document.activeElement)) document.activeElement.blur();

              // brief delay to allow blur to settle (matches your previous intent)
              setTimeout(() => {
                panel.setAttribute('aria-hidden', 'true');
                triggers.forEach((t) => {
                  t.setAttribute('aria-expanded', 'false');
                  t.setAttribute('aria-label', 'Open cart');
                });

                // return focus to first trigger without ring (optional)
                const focusBtn = triggers[0];
                if (focusBtn) {
                  focusBtn.classList.add('no-focus-outline');
                  focusBtn.focus();
                  setTimeout(() => focusBtn.classList.remove('no-focus-outline'), 100);
                }

                if (hasGSAP) {
                  window.gsap.to(panel, {
                    xPercent: 100,
                    autoAlpha: 0,
                    duration: 0.3,
                    ease: 'power2.in',
                  });
                } else {
                  panel.style.opacity = '0';
                  panel.style.transform = 'translateX(100%)';
                  panel.style.visibility = 'hidden';
                }

                overlayHideIfIdle();
              }, 30);
            }

            function toggleFromEvent(e) {
              hardStop(e);
              const hidden = panel.getAttribute('aria-hidden') === 'true';
              if (hidden) openPanel(e.currentTarget);
              else closePanel();
            }

            // Capture=true to win against other handlers
            triggers.forEach((btn) => btn.addEventListener('click', toggleFromEvent, { capture: true }));

            closeBtn.addEventListener(
              'click',
              function (e) {
                hardStop(e);
                closePanel();
              },
              { capture: true }
            );

            overlay.addEventListener('click', function () {
              if (overlay.classList.contains('cart-active') && panel.getAttribute('aria-hidden') === 'false') {
                closePanel();
              }
            });

            document.addEventListener('keydown', function (e) {
              if (e.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') {
                closePanel();
              }
            });

            window.MiniCart = {
              open: openPanel,
              close: closePanel,
              toggle: function () {
                const hidden = panel.getAttribute('aria-hidden') === 'true';
                if (hidden) openPanel(triggers[0]);
                else closePanel();
              },
            };
          } catch (err) {
            console.error('[Mini-Cart]', err.message);
          }
        }

        document.addEventListener('DOMContentLoaded', initMiniCart);
      })();